<div class="table-responsive" [ngStyle]="{overflowY:'hidden'}">

  <table id="abstractTable" class="table-responsive table table-bordered no-margin">


    <thead>
      <tr>
        <th *ngFor="let th of tableHeaderAndFooterColumns">{{th}}</th>
      </tr>
    </thead>

    <!-- tbody -->
    <ng-content></ng-content>
    <!-- end tbody -->

    <tfoot>
      <tr>
        <th *ngFor="let tf of tableHeaderAndFooterColumns">{{tf}}</th>
      </tr>
    </tfoot>

  </table>

</div>